import { FC, ReactNode } from 'react';
import { TextContainer, Container, Content, Header, Title } from './styled';

interface Props {
  title: string;
  align?: string;
  children: ReactNode;
  headerBackground?: string;
  isInverted?: boolean;
  smallTitle?: boolean;
  withoutPadding?: boolean;
}

export const ProfileCard: FC<Props> = ({
  title,
  children,
  headerBackground,
  isInverted,
  align,
  smallTitle,
  withoutPadding,
}) => {
  return (
    <Container>
      <Header $background={headerBackground} $isInverted={isInverted}>
        <TextContainer $align={align}>
          <Title $smallTitle={smallTitle} $isInverted={isInverted}>
            {title}
          </Title>
        </TextContainer>
      </Header>
      <Content $withoutPadding={withoutPadding}>{children}</Content>
    </Container>
  );
};
